import { useState } from "react";
import PropTypes from "prop-types";
import { TiTick } from "react-icons/ti";
import { FaTimes } from "react-icons/fa";
import { 
    RiRefreshLine, 
    RiArrowDownSLine 
} from "react-icons/ri";
import searchIcon from "../../../../assets/admin/search.svg";

const CatalogFilterSection = ({
    openDropdown,
    setOpenDropdown,
    dropdownRef,
    selectedNation,
    handleNationFilter,
    nations,
    selectedRegion,
    handleRegionFilter,
    regions,
    selectedGrape,
    handleGrapeFilter,
    grapeVarieties,
    selectedProductType,
    handleProductTypeFilter,
    productTypes,
    handleApplyFilters,
    handleResetFilters,
    searchNome,
    setSearchNome
}) => {
    // Internal dropdown search queries
    const [nationSearch, setNationSearch] = useState("");
    const [regionSearch, setRegionSearch] = useState("");
    const [grapeSearch, setGrapeSearch] = useState("");
    const [productTypeSearch, setProductTypeSearch] = useState("");

    const hasSelectedFilters =
        (selectedNation && selectedNation.length > 0) ||
        (selectedRegion && selectedRegion.length > 0) ||
        (selectedGrape && selectedGrape.length > 0) ||
        (selectedProductType && selectedProductType.length > 0);

    return (
        <div className="w-full space-y-4">
            {/* Selected Filters Tags Row */}
            {hasSelectedFilters && (
                <div className="flex flex-col pt-2 pb-1">
                    <h1 className="text-lg mb-3 font-medium text-[#303030]">Filtri Selezionati</h1>
                    <div className="flex flex-wrap gap-3">
                        {selectedNation && selectedNation.map((item) => (
                            <div key={item} className="flex w-fit items-center gap-1 px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200">
                                <p className="m-0 w-fit text-sm">{item}</p>
                                <FaTimes
                                    className="text-red-500 cursor-pointer"
                                    onClick={() => handleNationFilter(item)}
                                    title="Remove"
                                />
                            </div>
                        ))}
                        {selectedRegion && selectedRegion.map((item) => (
                            <div key={item} className="flex w-fit items-center gap-1 px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200">
                                <p className="m-0 w-fit text-sm">{item}</p>
                                <FaTimes
                                    className="text-red-500 cursor-pointer"
                                    onClick={() => handleRegionFilter(item)}
                                    title="Remove"
                                />
                            </div>
                        ))}
                        {selectedGrape && selectedGrape.map((item) => (
                            <div key={item} className="flex w-fit items-center gap-1 px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200">
                                <p className="m-0 w-fit text-sm">{item}</p>
                                <FaTimes
                                    className="text-red-500 cursor-pointer"
                                    onClick={() => handleGrapeFilter(item)}
                                    title="Remove"
                                />
                            </div>
                        ))}
                        {selectedProductType && selectedProductType.map((item) => (
                            <div key={item} className="flex w-fit items-center gap-1 px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200">
                                <p className="m-0 w-fit text-sm">{item}</p>
                                <FaTimes
                                    className="text-red-500 cursor-pointer"
                                    onClick={() => handleProductTypeFilter(item)}
                                    title="Remove"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Filter Section Title & Dropdowns */}
            <div ref={dropdownRef} className="w-full">
                <h1 className="text-xl flex items-center justify-between italic font-bold poppins-medium mb-3">
                    Scegli i vini:
                </h1>

                {/* Filter Dropdowns Row */}
                <div className="grid my-3 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 gap-3">
                    {/* Dropdown 1: Nazione */}
                    <div className="relative group w-full dropdown-container">
                        <button
                            type="button"
                            className={`${
                                openDropdown === 'nation'
                                    ? "border border-[#8B24335C] rounded-tl-3xl rounded-tr-3xl"
                                    : "rounded-full"
                            } border border-[#8B24335C] bg-[#FAF6F6] inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#DB7685] shadow-sm relative z-30`}
                            onClick={() => setOpenDropdown(openDropdown === 'nation' ? null : 'nation')}
                        >
                            <span className="mr-2 flex items-center gap-3 poppins-medium truncate">
                                {selectedNation && selectedNation.length > 0 ? selectedNation.join(", ") : "Nazione"}
                            </span>
                            <RiArrowDownSLine
                                className={`transform transition-transform duration-300 ${
                                    openDropdown === 'nation' ? "rotate-180" : ""
                                }`}
                                size={"20px"}
                            />
                        </button>

                        <div
                            className={`${
                                openDropdown === 'nation'
                                    ? "opacity-100 z-50 block"
                                    : "opacity-0 z-20 hidden"
                            } bg-[#FAF6F6] h-[320px] border border-[#8B24335C] overflow-y-scroll absolute top-[32px] pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full transition-all duration-300 ease-in-out`}
                        >
                            <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[21px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                                <img
                                    src={searchIcon}
                                    className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                                    alt="Search"
                                />
                                <input
                                    type="text"
                                    className="block poppins-regular bg-transparent outline-none w-full placeholder:text-sm"
                                    placeholder="..."
                                    value={nationSearch}
                                    onChange={(e) => setNationSearch(e.target.value)}
                                />
                            </div>

                            {(nations || []).length > 0 ? (
                                (nations || [])
                                    .filter((nat) => typeof nat === "string" && nat.toLowerCase().includes(nationSearch.toLowerCase()))
                                    .map((nat, i) => {
                                        const isChecked = selectedNation.includes(nat);
                                        return (
                                            <label
                                                key={i}
                                                className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn cursor-pointer"
                                                onClick={() => handleNationFilter(nat)}
                                            >
                                                <input
                                                    type="checkbox"
                                                    className="outline-none cursor-pointer"
                                                    checked={isChecked}
                                                    onChange={() => {}}
                                                />
                                                <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                                                    {nat}
                                                </span>
                                            </label>
                                        );
                                    })
                            ) : (
                                <label className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn">
                                    <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                                        No nazione data available
                                    </span>
                                </label>
                            )}
                        </div>
                    </div>

                    {/* Dropdown 2: Regione */}
                    <div className="relative group w-full dropdown-container">
                        <button
                            type="button"
                            className={`${
                                openDropdown === 'region'
                                    ? "border border-[#8B24335C] rounded-tl-3xl rounded-tr-3xl"
                                    : "rounded-full"
                            } border border-[#8B24335C] bg-[#FAF6F6] inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#DB7685] shadow-sm relative z-30`}
                            onClick={() => setOpenDropdown(openDropdown === 'region' ? null : 'region')}
                        >
                            <span className="mr-2 flex items-center gap-3 poppins-medium truncate">
                                {selectedRegion && selectedRegion.length > 0 ? selectedRegion.join(", ") : "Regione"}
                            </span>
                            <RiArrowDownSLine
                                className={`transform transition-transform duration-300 ${
                                    openDropdown === 'region' ? "rotate-180" : ""
                                }`}
                                size={"20px"}
                            />
                        </button>

                        <div
                            className={`${
                                openDropdown === 'region'
                                    ? "opacity-100 z-50 block"
                                    : "opacity-0 z-20 hidden"
                            } bg-[#FAF6F6] h-[320px] border border-[#8B24335C] overflow-y-scroll absolute top-[32px] pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full transition-all duration-300 ease-in-out`}
                        >
                            <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[21px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                                <img
                                    src={searchIcon}
                                    className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                                    alt="Search"
                                />
                                <input
                                    type="text"
                                    className="block poppins-regular bg-transparent outline-none w-full placeholder:text-sm"
                                    placeholder="..."
                                    value={regionSearch}
                                    onChange={(e) => setRegionSearch(e.target.value)}
                                />
                            </div>

                            {(regions || []).length > 0 ? (
                                (regions || [])
                                    .filter((reg) => typeof reg === "string" && reg.toLowerCase().includes(regionSearch.toLowerCase()))
                                    .map((reg, i) => {
                                        const isChecked = selectedRegion.includes(reg);
                                        return (
                                            <label
                                                key={i}
                                                className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn cursor-pointer"
                                                onClick={() => handleRegionFilter(reg)}
                                            >
                                                <input
                                                    type="checkbox"
                                                    className="outline-none cursor-pointer"
                                                    checked={isChecked}
                                                    onChange={() => {}}
                                                />
                                                <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                                                    {reg}
                                                </span>
                                            </label>
                                        );
                                    })
                            ) : (
                                <label className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn">
                                    <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                                        No regione data available
                                    </span>
                                </label>
                            )}
                        </div>
                    </div>

                    {/* Dropdown 3: Vitigno */}
                    <div className="relative group w-full dropdown-container">
                        <button
                            type="button"
                            className={`${
                                openDropdown === 'grape'
                                    ? "border border-[#8B24335C] rounded-tl-3xl rounded-tr-3xl"
                                    : "rounded-full"
                            } border border-[#8B24335C] bg-[#FAF6F6] inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#DB7685] shadow-sm relative z-30`}
                            onClick={() => setOpenDropdown(openDropdown === 'grape' ? null : 'grape')}
                        >
                            <span className="mr-2 flex items-center gap-3 poppins-medium truncate">
                                {selectedGrape && selectedGrape.length > 0 ? selectedGrape.join(", ") : "Vitigno"}
                            </span>
                            <RiArrowDownSLine
                                className={`transform transition-transform duration-300 ${
                                    openDropdown === 'grape' ? "rotate-180" : ""
                                }`}
                                size={"20px"}
                            />
                        </button>

                        <div
                            className={`${
                                openDropdown === 'grape'
                                    ? "opacity-100 z-50 block"
                                    : "opacity-0 z-20 hidden"
                            } bg-[#FAF6F6] h-[320px] border border-[#8B24335C] overflow-y-scroll absolute top-[32px] pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full transition-all duration-300 ease-in-out`}
                        >
                            <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[21px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                                <img
                                    src={searchIcon}
                                    className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                                    alt="Search"
                                />
                                <input
                                    type="text"
                                    className="block poppins-regular bg-transparent outline-none w-full placeholder:text-sm"
                                    placeholder="..."
                                    value={grapeSearch}
                                    onChange={(e) => setGrapeSearch(e.target.value)}
                                />
                            </div>

                            {(grapeVarieties || []).length > 0 ? (
                                (grapeVarieties || [])
                                    .filter((v) => typeof v === "string" && v.toLowerCase().includes(grapeSearch.toLowerCase()))
                                    .map((v, i) => {
                                        const isChecked = selectedGrape.includes(v);
                                        return (
                                            <label
                                                key={i}
                                                className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn cursor-pointer"
                                                onClick={() => handleGrapeFilter(v)}
                                            >
                                                <input
                                                    type="checkbox"
                                                    className="outline-none cursor-pointer"
                                                    checked={isChecked}
                                                    onChange={() => {}}
                                                />
                                                <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                                                    {v}
                                                </span>
                                            </label>
                                        );
                                    })
                            ) : (
                                <label className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn">
                                    <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                                        No vitigno data available
                                    </span>
                                </label>
                            )}
                        </div>
                    </div>

                    {/* Dropdown 4: Tipologia */}
                    <div className="relative group w-full dropdown-container">
                        <button
                            type="button"
                            className={`${
                                openDropdown === 'productType'
                                    ? "border border-[#8B24335C] rounded-tl-3xl rounded-tr-3xl"
                                    : "rounded-full"
                            } border border-[#8B24335C] bg-[#FAF6F6] inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#DB7685] shadow-sm relative z-30`}
                            onClick={() => setOpenDropdown(openDropdown === 'productType' ? null : 'productType')}
                        >
                            <span className="mr-2 flex items-center gap-3 poppins-medium truncate">
                                {selectedProductType && selectedProductType.length > 0 ? selectedProductType.join(", ") : "Tipologia"}
                            </span>
                            <RiArrowDownSLine
                                className={`transform transition-transform duration-300 ${
                                    openDropdown === 'productType' ? "rotate-180" : ""
                                }`}
                                size={"20px"}
                            />
                        </button>

                        <div
                            className={`${
                                openDropdown === 'productType'
                                    ? "opacity-100 z-50 block"
                                    : "opacity-0 z-20 hidden"
                            } bg-[#FAF6F6] h-[320px] border border-[#8B24335C] overflow-y-scroll absolute top-[32px] pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full transition-all duration-300 ease-in-out`}
                        >
                            <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[21px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                                <img
                                    src={searchIcon}
                                    className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                                    alt="Search"
                                />
                                <input
                                    type="text"
                                    className="block poppins-regular bg-transparent outline-none w-full placeholder:text-sm"
                                    placeholder="..."
                                    value={productTypeSearch}
                                    onChange={(e) => setProductTypeSearch(e.target.value)}
                                />
                            </div>

                            {(productTypes || []).length > 0 ? (
                                (productTypes || [])
                                    .filter((pt) => typeof pt === "string" && pt.toLowerCase().includes(productTypeSearch.toLowerCase()))
                                    .map((pt, i) => {
                                        const isChecked = selectedProductType.includes(pt);
                                        return (
                                            <label
                                                key={i}
                                                className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn cursor-pointer"
                                                onClick={() => handleProductTypeFilter(pt)}
                                            >
                                                <input
                                                    type="checkbox"
                                                    className="outline-none cursor-pointer"
                                                    checked={isChecked}
                                                    onChange={() => {}}
                                                />
                                                <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                                                    {pt}
                                                </span>
                                            </label>
                                        );
                                    })
                            ) : (
                                <label className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn">
                                    <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                                        No tipologia data available
                                    </span>
                                </label>
                            )}
                        </div>
                    </div>
                </div>

                {/* Filter Action Buttons */}
                <div className="flex gap-3 mt-5 mb-3">
                    <button
                        type="button"
                        className="w-auto flex justify-center py-2 ps-4 pe-5 items-center text-sm bg-[#8A2533] text-white rounded-3xl border-2 border-[#953543] hover:text-[#8A2533] hover:bg-[#f6efef] transition-colors group cursor-pointer"
                        onClick={handleApplyFilters}
                    >
                        <TiTick className="w-4 h-4 mr-2" />
                        <span className="poppins-regular text-sm">Applica</span>
                    </button>
                    <button
                        type="button"
                        className="w-auto flex justify-center py-2 ps-4 pe-5 items-center text-sm bg-[#8A2533] text-white rounded-3xl border-2 border-[#953543] hover:text-[#8A2533] hover:bg-[#f6efef] transition-colors group cursor-pointer"
                        onClick={handleResetFilters}
                    >
                        <RiRefreshLine className="w-4 h-4 mr-2" />
                        <span className="poppins-regular text-sm">Reimposta</span>
                    </button>
                </div>

                {/* Search Field Row */}
                <div className="pt-2">
                    <div className="relative flex items-center">
                        <img 
                            src={searchIcon} 
                            alt="Search" 
                            className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 opacity-50 pointer-events-none" 
                        />
                        <input
                            type="text"
                            placeholder="Nome"
                            value={searchNome}
                            onChange={(e) => setSearchNome(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleApplyFilters();
                                }
                            }}
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-full text-sm poppins-regular focus:outline-none focus:border-[#8B2433]"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

CatalogFilterSection.propTypes = {
    openDropdown: PropTypes.string,
    setOpenDropdown: PropTypes.func.isRequired,
    dropdownRef: PropTypes.object,
    selectedNation: PropTypes.array.isRequired,
    handleNationFilter: PropTypes.func.isRequired,
    nations: PropTypes.array.isRequired,
    selectedRegion: PropTypes.array.isRequired,
    handleRegionFilter: PropTypes.func.isRequired,
    regions: PropTypes.array.isRequired,
    selectedGrape: PropTypes.array.isRequired,
    handleGrapeFilter: PropTypes.func.isRequired,
    grapeVarieties: PropTypes.array.isRequired,
    selectedProductType: PropTypes.array.isRequired,
    handleProductTypeFilter: PropTypes.func.isRequired,
    productTypes: PropTypes.array.isRequired,
    handleApplyFilters: PropTypes.func.isRequired,
    handleResetFilters: PropTypes.func.isRequired,
    searchNome: PropTypes.string,
    setSearchNome: PropTypes.func.isRequired
};

export default CatalogFilterSection;

